import { UserRoleType } from "api/interface";
import { UnknownObject } from "common/type";
// import { getLocalStorageItem, i18n, initWindowFunc } from "core";
import _ from "lodash";
import moment from "moment";
import { NETWORKS, ONREKORD_WHITE_GLOVE_WALLETS } from "common/constants";
import { message } from "antd";

export const scrollTop = (): void => {
	window.scrollTo(0, 0);
};

export const removeBodyScroll = (): void => {
	document.body.style.overflow = "hidden";
};

export const revertBodyScroll = (): void => {
	document.body.style.overflow = "";
};

export const validationObject = (object: UnknownObject): boolean => {
	const keys: string[] = Object.keys(object);

	if (_.isEmpty(keys)) return false;

	return keys.every((key: string) => {
		return !_.isUndefined(object[key]) && !_.isEmpty(object[key]);
	});
};

export const isUser = (role: UserRoleType): boolean => role === "user";

export const isAdmin = (role: UserRoleType): boolean => role === "admin";

export const setDefaultLanguage = (): void => {
	// const localStorageLng = getLocalStorageItem("lng");
	// if (!_.isNull(localStorageLng) && localStorageLng !== i18n.language) {
	// 	i18n.changeLanguage(localStorageLng);
	// }
};

export const setWindowFunction = ({
	initUserInfoAction,
	showModalAction,
}: {
	initUserInfoAction: Function;
	showModalAction: Function;
}): void => {
	// initWindowFunc({
	// 	initUserInfoAction,
	// 	showModalAction,
	// });
};

export async function authHeader() {
	const token = await localStorage.getItem("accessToken");
	return `Bearer ${token}`;
}

export function assetTypeIcon(mimetype?: string) {
	// text/csv
	// application/msword
	// image/jpeg
	//  audio/mpeg
	//  video/mp4

	if (!mimetype) return "image.svg";
	const mimeTypeArr = mimetype.split("/");
	return mimeTypeArr[0] + ".svg";
}

export function assetPreview(url?: string, mimetype?: string) {
	let prevImg = "assets/images/filetypes/";
	if (!mimetype) return prevImg;
	const mimeTypeArr = mimetype.split("/");
	if (mimeTypeArr[0] && mimeTypeArr[0] !== "image") {
		return prevImg + mimeTypeArr[0] + ".svg";
	}
	return url;
}

export function reArangeFilters(filters = {}) {
	let queryString = "?";
	for (const [key, value] of Object.entries(filters)) {
		if (Array.isArray(value)) {
			for (let item of value) {
				queryString = `${queryString}${key}=${item}&`;
			}
		} else {
			queryString = `${queryString}${key}=${value}&`;
		}
	}
	return queryString !== "?" ? queryString : "";
}

export function getCenterShort(text: string | undefined, lettersLength = 6) {
	return (
		text?.slice(0, lettersLength) +
		"..." +
		text?.slice(text.length - lettersLength)
	);
}

export function calculateFileSize(sizeInBytes: number) {
	if (!sizeInBytes) return 0;
	const sizeTypes = ["Bytes", "KB", "MB", "GB"];
	let fSize = sizeInBytes;
	let i = 0;
	while (fSize > 900) {
		fSize /= 1024;
		i++;
	}
	return Math.round(fSize * 100) / 100 + " " + sizeTypes[i];
}

export async function downloadAsset(
  src: string,
  mimetype: string,
  title: string
) {
  try {
    const response = await fetch(src);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(
      new Blob([blob], { type: mimetype })
    );

    const a = document.createElement("a");
    a.href = url;
    a.download = title || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();

    // cleanup
    setTimeout(() => window.URL.revokeObjectURL(url), 150);
  } catch (err) {
    console.error("Download failed:", err);
  }
}

export function downloadMyFileAssets(
  src: string,
  title: string
) {
  const a = document.createElement("a");
  a.href = src;
  a.download = title || "download";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}


export function handleCheckStatus(
	expDate: string | undefined,
	status: string | undefined
) {
	const currentDate = moment(new Date());
	const expiryDate = moment(expDate);

	if (!moment(expiryDate).isAfter(currentDate) && status == "PENDING") {
		status = "EXPIRED";
	}
	return status;
}

export function validateEmail(email: string) {
	// Regular expression for email validation
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
}

export function getNFTURL(tokenId: number, networkId: number) {
	const network = NETWORKS[networkId];
	if (!network) return undefined;
	return `${network.blockExplorerUrl}token/${network.contractAddress}?a=${tokenId}`;
}

export function sortedDataList(array: Array<any>) {
	return array.slice().sort((a, b) => {
		const lastNameA = a.contributor?.last_name?.toLowerCase() ?? "";
		const lastNameB = b.contributor?.last_name?.toLowerCase() ?? "";
		const firstNameA = a.contributor?.first_name?.toLowerCase() ?? "";
		const firstNameB = b.contributor?.first_name?.toLowerCase() ?? "";

		if (lastNameA < lastNameB) return -1;
		if (lastNameA > lastNameB) return 1;
		if (firstNameA < firstNameB) return -1;
		if (firstNameA > firstNameB) return 1;
		return 0;
	});
}

export function updateFavicon(count: number) {
	const favicon = document.getElementById("favicon") as HTMLLinkElement;
	if (!favicon) return;

	const faviconUrl = favicon.href;
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");

	const size = 32;
	canvas.width = size;
	canvas.height = size;

	const img = new Image();
	img.src = faviconUrl;

	img.onload = () => {
		if (!ctx) return;

		// Draw the original favicon
		ctx.drawImage(img, 0, 0, size, size);

		if (count > 0) {
			// Draw the notification circle
			ctx.beginPath();
			ctx.arc(size - 8, 8, 8, 0, 2 * Math.PI);
			ctx.fillStyle = "#ff0000";
			ctx.fill();

			// Draw the count number
			ctx.fillStyle = "#fff";
			ctx.font = "10px Arial";
			ctx.textAlign = "center";
			ctx.textBaseline = "middle";
			ctx.fillText(count.toString(), size - 8, 8);
		}

		favicon.href = canvas.toDataURL("image/png");
	};
}

export function updateTitleNotification(count: number) {
	if (count > 0) {
		document.title = `(${count}) OnRekord`;
	} else {
		document.title = "OnRekord";
	}
}

export function getHeadingText(path: string): string {
	switch (true) {
		case path.includes("/super-nft"):
			return "Rekord Dashboard";
		case path.includes("/nftlibrary"):
			return "Rekord Library";
		case path.includes("/collection-library"):
			return "Collection Library";
		case path.includes("/admin"):
			return "Admin Analysis";
		case path.includes("/my-files"):
			return "My Files";
		case path.includes("/contributors"):
			return "Contributors";
		case path.includes("/contributions"):
			return "Contributions";
		case path.includes("/recent-files"):
			return "Recent Files";
		case path.includes("-profile"):
			return "Profile";
		case path.includes("-notifications"):
			return "Notifications";
		case path.includes("-identity-verification"):
			return "Verification";
		case path.includes("profile-on-record-wallet"):
			return "OnRekord wallet";
		default:
			return "Dashboard";
	}
}

function detectMime(bytes: Uint8Array): string | null {
  // --- Images ---
  // PNG
  if (
    bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47 &&
    bytes[4] === 0x0d && bytes[5] === 0x0a && bytes[6] === 0x1a && bytes[7] === 0x0a
  ) {
    return "image/png";
  }

  // JPEG
  if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
    return "image/jpeg";
  }

  // GIF (87a / 89a)
  const gif87a = [0x47, 0x49, 0x46, 0x38, 0x37, 0x61]; // "GIF87a"
  const gif89a = [0x47, 0x49, 0x46, 0x38, 0x39, 0x61]; // "GIF89a"
  if (gif87a.every((b, i) => b === bytes[i]) || gif89a.every((b, i) => b === bytes[i])) {
    return "image/gif";
  }

  // WebP
  if (
    bytes[0] === 0x52 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x46 &&
    bytes[8] === 0x57 && bytes[9] === 0x45 && bytes[10] === 0x42 && bytes[11] === 0x50
  ) {
    return "image/webp";
  }

  // SVG → no fixed magic number, must check text content later
  const svgHeader = new TextDecoder().decode(bytes.slice(0, 16)).toLowerCase();
  if (svgHeader.includes("<svg")) {
    return "image/svg+xml";
  }

  // --- Documents ---
  // PDF
  if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) {
    return "application/pdf";
  }

  // MS Office (doc/xls/ppt) old formats
  if (
    bytes[0] === 0xd0 && bytes[1] === 0xcf && bytes[2] === 0x11 &&
    bytes[3] === 0xe0 && bytes[4] === 0xa1 && bytes[5] === 0xb1 &&
    bytes[6] === 0x1a && bytes[7] === 0xe1
  ) {
    // Compound File Binary Format → could be DOC, XLS, PPT
    return "application/vnd.ms-office";
  }

  // DOCX / XLSX / PPTX (all are ZIP files with different internal structure)
  if (bytes[0] === 0x50 && bytes[1] === 0x4b && bytes[2] === 0x03 && bytes[3] === 0x04) {
    return "application/vnd.openxmlformats-officedocument";
  }

  // --- Archives ---
  // ZIP
  if (bytes[0] === 0x50 && bytes[1] === 0x4b && (bytes[2] === 0x03 || bytes[2] === 0x05 || bytes[2] === 0x07)) {
    return "application/zip";
  }

  // --- Audio ---
  // MP3 (ID3 or frame sync)
  if (
    (bytes[0] === 0x49 && bytes[1] === 0x44 && bytes[2] === 0x33) || // ID3
    (bytes[0] === 0xff && (bytes[1] & 0xe0) === 0xe0) // Frame sync
  ) {
    return "audio/mpeg";
  }

  // WAV (RIFF WAVE)
  if (
    bytes[0] === 0x52 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x46 &&
    bytes[8] === 0x57 && bytes[9] === 0x41 && bytes[10] === 0x56 && bytes[11] === 0x45
  ) {
    return "audio/wav";
  }

  // --- Video ---
  // MP4 ("ftyp" at offset 4)
  const brand = new TextDecoder().decode(bytes.slice(4, 8));
  if (brand === "ftyp") {
    return "video/mp4";
  }

  // MOV (QuickTime)
  if (
    bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 && bytes[7] === 0x70
  ) {
    const movBrand = new TextDecoder().decode(bytes.slice(8, 12));
    if (movBrand.startsWith("qt")) {
      return "video/quicktime";
    }
	}
	
	// WebM (EBML header)
	if (
		bytes[0] === 0x1a &&
		bytes[1] === 0x45 &&
		bytes[2] === 0xdf &&
		bytes[3] === 0xa3
	) {
		return "video/webm";
	}

  return null;
}


export async function validateFile(file: any): Promise<boolean> {
	if (!file || file.size === 0) {
		message.error("File is empty or missing.");
		return false;
	}

	const buffer = await file.slice(0, 64).arrayBuffer();
  const bytes = new Uint8Array(buffer);

	const detected = detectMime(bytes);

  if (!detected) {
    message.error("Unsupported or corrupted file.");
    return false;
  }

  // If you want strict enforcement
  // if (file.type && file.type !== detected) {
  //   message.error(`File type mismatch. Expected: ${file.type}, Detected: ${detected}`);
  //   return false;
  // }

  return true;
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  const value = bytes / Math.pow(k, i);

  return `${value.toFixed(2)} ${sizes[i]}`;
};

export const isWhiteGloveWallet = (address?: string): boolean => {
  if (!address) return false;
  return ONREKORD_WHITE_GLOVE_WALLETS.some(
    (wallet) => wallet.toLowerCase() === address.toLowerCase()
  );
}

export function formatBigNumber(value: number | string): string {
  return Number(value).toLocaleString('en-US');
}

export const RPCS = {
  mainnet: process.env.REACT_APP_MAINNET,
  sepolia: process.env.REACT_APP_RPC_SEPOLIA,
  polygon: process.env.REACT_APP_RPC_POLYGON,
  polygonAmoy: process.env.REACT_APP_POLYGON_AMOY,
  bsc: process.env.REACT_APP_BSC,
  bscTestnet: process.env.REACT_APP_BSC_TESTNET,
} as const;
